import React from 'react';
import { Loader2 } from 'lucide-react';

const UserTransitionLoader = () => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
        <p className="text-gray-700 font-medium">Carregando seus dados...</p>
        <p className="text-sm text-gray-500">Aguarde um momento</p>
      </div>
    </div>
  );
};

export default UserTransitionLoader;
